import React from "react";
import { AuthRoles } from "../../../configs/roles";
import { UserManagementUIProvider } from "./UserManagementUIContext";

//MENU
import { UserManagementUICard } from "./UserManagementUICard";
import {CreateUser} from "./pages/CreateUser"
import {EditUser} from "./pages/EditUser"
import {DeleteUser} from "./pages/DeleteUser"
import {ChangePassUser} from "./pages/ChangePassUser"

export const UserManagementRoutes = [
  {
    path: "/user-management",
    element: (
      <UserManagementUIProvider>
        <UserManagementUICard />
      </UserManagementUIProvider>
    ),
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/user-management/create",
    element: <CreateUser/>,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/user-management/:id/edit",
    element: <EditUser />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/user-management/:id/delete",
    element: <DeleteUser />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/user-management/:id/changepass",
    element: <ChangePassUser />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  
];
